<template>
  <div
    :class="[{ 'fixed inset-0 flex items-center justify-center flex-col mb-100': fullPage }]"
  >
    <div class="circle-progress">
      <svg
        class="circle-progress__svg"
        viewBox="-2 -2 108 108"
        :width="getCircleSize"
        :height="getCircleSize"
      >
        <circle
          class="circle-progress--circle circle-progress-fill-line--back"
          :r="radius"
          cx="52"
          cy="52"
        />
        <circle
          ref="fillingCircle"
          :class="fillCircleClasses"
          :style="fillingCircleStyles"
          :r="radius"
          cx="52"
          cy="52"
          transform="rotate(270 52 52)"
        />
      </svg>

      <div class="circle-progress--content">
        <icon
          icon="check"
          :size="getCheckmarkSize"
          color="#05421a"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {ref, defineComponent, reactive} from 'vue';
import {useI18n} from "vue-i18n";
import Icon from "../components/Icon.vue";

export default defineComponent({
  name: "FinishedAnimation",
  components: {Icon},
  props: {
    fullPage: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "medium",
      validator: (value) => {
        return ['icon-small', 'small', 'medium', 'large'].includes(value);
      }
    }
  },
  setup(props) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    props = reactive(props);
    const {t} = useI18n();

    return {
      fillingCircle: ref(null),
      radius: ref(48),
      t
    };
  },
  computed: {
    fillCircleClasses() {
      return {
        "circle-progress--circle": true,
        "circle-progress-fill--value": !this.noProgress,
        "circle-progress-fill-line": true
      };
    },
    noProgress() {
      return false;
    },
    getCircleSize() {
      switch(this.size) {
        case "icon-small":
          return 20;
        case "small":
          return 30;
        case "medium":
          return 100;
        case "large":
          return 200;
        default:
          return 100;
      }
    },

    getCheckmarkSize() {
      switch(this.size) {
        case "icon-small":
          return "12px";
        case "small":
          return "15px";
        case "medium":
          return "60px";
        case "large":
          return "100px";
        default:
          return 100;
      }
    },
    dashArray() {
      return (this.radius * Math.PI * 2);
    },
    dashOffset() {
      return this.dashArray - this.dashArray;
    },
    fillingCircleStyles() {
      return {
        'strokeDashoffset': this.dashOffset,
        'strokeDasharray': this.dashArray,
      };
    }
  },
});
</script>
<style lang="scss" scoped>
@keyframes filling {
  from {
    stroke-dashoffset: v-bind("dashArray");
  }
  to {
    stroke-dashoffset: v-bind("dashOffset");
  }
}

@keyframes spinning {
  0% {
    stroke-dashoffset: 0;
  }
  66% {
    stroke-dashoffset: v-bind("dashArray");;
  }
}

.circle-progress-fill--value {
  animation-name: filling;
  animation-duration: 1s;
  animation-timing-function: ease-in-out;
  transition: 0.5s all;
}

.circle-progress-fill--no-value {
  animation-name: spinning;
  animation-duration: 2s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite; /* Run the animation continuously */
  transition: 0.5s all;
}

.circle-progress--circle {
  fill: transparent;
  stroke-width: 6px;
}

.circle-progress-fill-line--back {
  stroke: transparent;
  stroke-dashoffset: 0;
}

.circle-progress {
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
}

.circle-progress-fill-line {
  @apply stroke-default_primary_dark;
}

.circle-progress--content {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

</style>
